import Component from './Component';
import Flickity from 'flickity';
import {swiffyslider} from 'swiffy-slider';

// This is made so that it can be used globally.
window.satc.runFlickityOnRelatedContentProduct = runFlickityOnRelatedContentProduct;
window.satc.runSwiffysliderOnRelatedContentProduct = runSwiffysliderOnRelatedContentProduct;

export default class RelatedContent extends Component {
  load() {
    // Flickity carousel is legacy and we will gradually remove it and use SwiffySlider instead.
    global.swiffyslider = swiffyslider;  // add swiffyslider function to the global/window object
    global.swiffyslider.init();          // start swiffyslider
    // console.log('swiffyslider : ', global.swiffyslider );

    this.initFlickity();
    super.load();
  }

  initFlickity() {

    const relatedContent = document.querySelectorAll('.js-related-content__banner');
    if(relatedContent) {
      Array.prototype.slice.call(relatedContent).map((el) => {
        // Skip carousels already initialised - re-running load() (e.g. on each day-tab
        // activation) must not create a second Flickity or stack window handlers.
        if (el.classList.contains('flickity-enabled')) return;

        const relatedContentFlickity = new Flickity(el, {
          cellAlign: 'center',
          contain: false,
          pageDots: true,
          prevNextButtons: true,
          wrapAround: true,
          imagesLoaded: true,
        });

        $(window).on('resize load', window.requestAnimationFrame.bind(window, () => {
          [
            { minSize: 0, group: 1 },
            { minSize: 560, group: 2 },
            { minSize: 992, group: 3 },
          ].reverse().find((size) => {
            if($(window).width() >= size.minSize) {
              if(relatedContentFlickity.options.groupCells !== size.group) {
                relatedContentFlickity.options.groupCells = size.group;
                relatedContentFlickity.options.wrapAround = (relatedContentFlickity.cells.length > size.group);

                relatedContentFlickity.resize();
              }

              return size;
            }
          });
        }));
      });
    }

    runFlickityOnRelatedContentProduct();

    const sixColProduct = document.querySelectorAll('.related-content--six-col .related-content__list');
    if(sixColProduct) {
      Array.prototype.slice.call(sixColProduct).map((el) => {
        if (el.classList.contains('flickity-enabled')) return;
        const autoPlay = el.dataset.autoplay === 'true';

        const relatedContentFlickity = new Flickity(el, {
          cellAlign: 'left',
          contain: true,
          pageDots: true,
          prevNextButtons: true,
          wrapAround: true,
          autoPlay: autoPlay,
        });

        $(window).on('resize load', window.requestAnimationFrame.bind(window, () => {
          [
            { minSize: 0, group: 1 },
            { minSize: 768, group: 2 },
            { minSize: 992, group: 3 },
            { minSize: 1200, group: 6 },
          ].reverse().find((size) => {
            if($(window).width() >= size.minSize) {
              if(relatedContentFlickity.options.groupCells !== size.group) {
                relatedContentFlickity.options.groupCells = size.group;

                relatedContentFlickity.resize();
              }

              return size;
            }
          });
        }));
      });
    }
  }

}

// Item 4 — Itinerary product carousel: keep a consistent card size and let the
// visible card COUNT flex with the available container width (driven by the
// map/content split slider), instead of stretching a fixed number of cards.
// These constants pair with --itinerary-card-width in ItineraryModule.scss.
const ITINERARY_CARD_TARGET = 280; // px
// Cells tile edge-to-edge: the visual gap comes from the cell's own 13px horizontal
// padding (.related-content--product .related-content__list-item), which box-sizing
// keeps INSIDE the 280px cell width - so there is no extra external gap to add.
const ITINERARY_CARD_GAP = 0;      // px (between-cell margin, outside the cell width)
const ITINERARY_CARDS_MIN = 1;
const ITINERARY_CARDS_MAX = 4;

function computeItineraryCardsThatFit(containerWidth) {
  if (!containerWidth || containerWidth <= 0) return 2;
  // N cards occupy N*TARGET + (N-1)*GAP pixels
  const fit = Math.floor((containerWidth + ITINERARY_CARD_GAP) /
                         (ITINERARY_CARD_TARGET + ITINERARY_CARD_GAP));
  return Math.max(ITINERARY_CARDS_MIN, Math.min(ITINERARY_CARDS_MAX, fit));
}

function debounce(fn, wait) {
  let timer = null;
  return function debounced(...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), wait);
  };
}

function runFlickityOnRelatedContentProduct() {
  const relatedContentProduct = document.querySelectorAll('.related-content--product .related-content__list');
  if (relatedContentProduct) {
    Array.prototype.slice.call(relatedContentProduct).map((el) => {
      // Skip carousels already initialised so repeated load() calls (per day-tab
      // activation) don't double-init or stack resize / split-resize handlers.
      if (el.classList.contains('flickity-enabled')) return;
      const isInItineraryTab = el.closest('.ItineraryModule, .itinerary-module');
      const baseOptions = {
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: true,
        wrapAround: true,
      };
      if (isInItineraryTab) {
        baseOptions.groupCells = 2; // initial; recomputed from container width below
      }
      const relatedContentFlickity = new Flickity(el, baseOptions);

      if (isInItineraryTab) {
        // Derive cards-per-view from the carousel's own available width (not
        // window breakpoints) so dragging the map/content split changes the
        // card COUNT at a stable card size. Scoped to this module so multiple
        // itinerary modules on a page don't cross-talk.
        const moduleRoot = el.closest('.ItineraryModule, .itinerary-module') || el;

        const recomputeCards = debounce(() => {
          if (!el.isConnected) return; // content moved/cloned away
          const viewport = el.querySelector('.flickity-viewport') || el;
          const available = viewport.getBoundingClientRect().width;
          // Skip while the carousel is hidden (inactive day tab -> width 0). Otherwise a
          // window resize would pin every hidden tab's carousel to the fallback count;
          // instead we leave its current value and recompute when the tab is next shown.
          if (available <= 0) return;
          const group = computeItineraryCardsThatFit(available);
          if (relatedContentFlickity.options.groupCells !== group) {
            relatedContentFlickity.options.groupCells = group;
            relatedContentFlickity.options.wrapAround =
              relatedContentFlickity.cells.length > group;
            relatedContentFlickity.resize();
          }
        }, 150);

        // Initial compute once layout has settled
        requestAnimationFrame(recomputeCards);

        // Window resize (tab-show fallback) + scoped split-resize notification
        $(window).on('resize load', recomputeCards);
        moduleRoot.addEventListener('itinerary:split-resize', recomputeCards);
      } else {
        // Non-itinerary carousels: unchanged window-breakpoint behaviour
        $(window).on('resize load', window.requestAnimationFrame.bind(window, () => {
          const maxGroup = 4;
          [
            { minSize: 0, group: 1 },
            { minSize: 768, group: 2 },
            { minSize: 992, group: 3 },
            { minSize: 1200, group: 4 },
          ].reverse().find((size) => {
            if ($(window).width() >= size.minSize) {
              const group = Math.min(size.group, maxGroup);
              if (relatedContentFlickity.options.groupCells !== group) {
                relatedContentFlickity.options.groupCells = group;
                relatedContentFlickity.resize();
              }
              return size;
            }
          });
        }));
      }
    });
  }
}

function runSwiffysliderOnRelatedContentProduct() {
  global.swiffyslider = swiffyslider;  // add swiffyslider function to the global/window object
  global.swiffyslider.init();          // start swiffyslider
}